import { render } from "./BeneficiariesTable.vue?vue&type=template&id=e3443d4c&scoped=true"
import script from "./BeneficiariesTable.vue?vue&type=script&lang=js"
export * from "./BeneficiariesTable.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=e3443d4c&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3443d4c"]])

export default __exports__